export const isAtom = (v) => {
  if (typeof v !== 'string' &&
    typeof v !== 'number' &&
    typeof v !== 'boolean' &&
    v !== null &&
    v !== undefined) {
    return false
  }
  return true
}

export const isString = (v) => typeof v === 'string'
export const isNumber = (v) => typeof v === 'number'
export const isBoolean = (v) => typeof v === 'boolean'
export const isNull = (v) => v === null
export const isUndefined = (v) => v === undefined
export const isFalsy = (v) => !v
export const isFunction = (v) => typeof v === 'function'
export const isNullArray = (v) => !v || v.length === 0

export const isObject = (v) => {
  return !!(v && typeof v === 'object' && !isArray(v))
}

export const isArray = (v) => Array.isArray(v)

export const isObjectOrArray = (v) => isObject(v) || isArray(v)

export const isIntegerStr = (v) => !isNaN(Number(v.toString())) && !v.includes('.')

export const getType = (v) => {
  const tpe = typeof v
  if (tpe === 'string' || tpe === 'number' || tpe === 'boolean' || tpe === 'function') {
    return tpe
  }
  if (v === null) return 'null'
  if (v === undefined) return 'undefined'
  if (Array.isArray(v)) return 'array'
  return 'object'
}
